import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIntroTopLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 963,
	height: 580,
	viewBox: "0 0 963 580",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M-848.49 579.62V-1242.75H962.85C742.18 173.43 560.11 359.18 -848.49 579.62Z",
			fill: "#303651"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_15_1124",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: -789,
			y: -1174,
			width: 1710,
			height: 1746,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M-762.85 571.14L-788.4 -1148.06L920.39 -1173.46C732.07 165.64 562.91 343.43 -762.85 571.14Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_15_1124)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M601.04 101.49C542.8 101.49 542.8 36.08 484.56 36.08C426.32 36.08 426.32 101.49 368.08 101.49C309.84 101.49 309.84 36.08 251.6 36.08C193.36 36.08 193.36 101.49 135.12 101.49C76.8801 101.49 76.8802 36.08 18.6402 36.08C-39.5998 36.08 -39.5998 101.49 -97.8498 101.49C-156.1 101.49 -156.09 36.08 -214.34 36.08",
					stroke: "#FF9900",
					strokeWidth: 29.35,
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M601.04 249.88C542.8 249.88 542.8 184.47 484.56 184.47C426.32 184.47 426.32 249.88 368.08 249.88C309.84 249.88 309.84 184.47 251.6 184.47C193.36 184.47 193.36 249.88 135.12 249.88C76.8801 249.88 76.8802 184.47 18.6402 184.47C-39.5998 184.47 -39.5998 249.88 -97.8498 249.88C-156.1 249.88 -156.09 184.47 -214.34 184.47",
					stroke: "#FF9900",
					strokeWidth: 29.35,
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M601.04 398.27C542.8 398.27 542.8 332.86 484.56 332.86C426.32 332.86 426.32 398.27 368.08 398.27C309.84 398.27 309.84 332.86 251.6 332.86C193.36 332.86 193.36 398.27 135.12 398.27C76.8801 398.27 76.8802 332.86 18.6402 332.86C-39.5998 332.86 -39.5998 398.27 -97.8498 398.27C-156.1 398.27 -156.09 332.86 -214.34 332.86",
					stroke: "#FF9900",
					strokeWidth: 29.35,
					strokeMiterlimit: 10
				})
			]
		})
	]
});
export default SvgIntroTopLeft;
